import { useSelector } from 'react-redux';

const useAverageByDataType = (conceptDataType, isGlobalPercentage) => {
  const conceptAverages = useSelector((state) => state.resonance.conceptAverages);
  const upperCaseDataType = conceptDataType.toUpperCase();

  if (!conceptAverages) {
    return [];
  }

  const averages = conceptAverages[upperCaseDataType]?.map((averageElement) => ({
    name: averageElement.subHeader,
    value: isGlobalPercentage ? averageElement.globalAvg : averageElement.avg,
  }));
  averages?.sort((a, b) => a.name.localeCompare(b.name));

  return averages ?? [];
};

export default useAverageByDataType;
